import { TRAVEL_DIRECTION_LABELS, type TravelDirection } from "../constants";

/** "Entry", "Exit" or "Unknown"; `null` when the sighting has no direction. */
export function formatTravelDirection(travelDirection: TravelDirection | null | undefined): string | null {
  return travelDirection ? TRAVEL_DIRECTION_LABELS[travelDirection] : null;
}
